import { passCodes } from '../passCodes';
import cipher25Image1 from '../../../../assets/images/games/zdar-escape-game/ciphers/25/image1.webp';
import cipher25Image2 from '../../../../assets/images/games/zdar-escape-game/ciphers/25/image2.webp';
import cipher25Image3 from '../../../../assets/images/games/zdar-escape-game/ciphers/25/image3.webp';
import cipher25Image4 from '../../../../assets/images/games/zdar-escape-game/ciphers/25/image4.webp';
import cipher25Image5 from '../../../../assets/images/games/zdar-escape-game/ciphers/25/image5.webp';
import cipher25Image6 from '../../../../assets/images/games/zdar-escape-game/ciphers/25/image6.webp';
import cipher25Image7 from '../../../../assets/images/games/zdar-escape-game/ciphers/25/image7.webp';
import cipher25Image8 from '../../../../assets/images/games/zdar-escape-game/ciphers/25/image8.webp';
import track25 from '../../../../assets/audio/tracks/track25.mp3';

const cipher25Images = [
    cipher25Image1,
    cipher25Image2,
    cipher25Image3,
    cipher25Image4,
    cipher25Image5,
    cipher25Image6,
    cipher25Image7,
    cipher25Image8,
];

const hints = [
    {
        text: 'Seřaďte obrázky v správnem pořadí podle mozaiky před vámi.',
    },
    {
        text: 'Kódem je: baklažán',
        solution: true,
    },
];
export const step25mosaic = {
    id: 23,
    title: '11. stanoviště',
    taskText: `
        <p>
            Hmm koukni se, tady máš nějaký nápad ohledně toho, co bys mohl najít. Co teď ale s ním? 
        </p>
    `,
    catImage: 8,
    audio: track25,
    snowAudio: track25,
    cipher: {
        label: 'Úkol',
        images: cipher25Images,
        isPathFinder: false,
    },
    codeInputText: 'Zadejte kód',
    codeInputPassCodeRegexp: passCodes[16],
    additionalInfo: 'Odpovědí je jedno české slovo.',
    hints: hints,
    snowHints: hints,
};
